import { createEvent, createStore, sample } from 'effector';

export type View = 'landing' | 'login' | 'onboard' | 'kyc' | 'processing' | 'report' | 'history';

export const PROTECTED_VIEWS: ReadonlySet<View> = new Set<View>([
  'onboard',
  'kyc',
  'processing',
  'report',
  'history',
]);

export const navigated = createEvent<View>();

export const $view = createStore<View>('landing').on(navigated, (_, next) => next);

// Какой отчёт открыт в Report.tsx. null = latest. Устанавливается из
// ReportHistory клик-handler'ом; queryFn'ы Report.tsx передают это
// значение в URL как `?id=...`.
export const reportSelected = createEvent<string | null>();
export const $selectedReportId = createStore<string | null>(null).on(reportSelected, (_, id) => id);

// Клик по отчёту в истории сразу переключает на report-view.
// reportSelected(null) — сброс к latest, без навигации (его делают
// другие sample'ы — completed-search или resume-flow).
sample({
  clock: reportSelected,
  filter: (id) => id !== null,
  fn: (): View => 'report',
  target: navigated,
});

if (typeof window !== 'undefined') {
  $view.watch(() => window.scrollTo({ top: 0, behavior: 'smooth' }));
}
